export default __webpack_public_path__ + "static/media/Sello_linexperts_X.b3a1fdae.png";